<template>
    <div>
        <BasePage/>
    </div>
</template>

<script>
import BasePage from './views/BasePage';
export default {
    name: 'AppNew',
    components: {BasePage}
};
</script>

<style scoped>

</style>